/**
 * Formata CPF (11 dígitos) ou CNPJ (14 dígitos) para exibição, removendo ou reaplicando a máscara.
 * @param {string|number|null|undefined} value
 * @returns {string} Valor formatado; string vazia se não houver conteúdo
 */
export function formatCpfCnpjDisplay(value) {
  if (value == null) {
    return ''
  }
  const str = String(value).trim()
  if (str === '') {
    return ''
  }
  const digits = str.replace(/\D/g, '')
  if (digits.length === 11) {
    return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
  }
  if (digits.length === 14) {
    return digits.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
  }
  // Dados parciais ou inesperados: exibe o que veio, sem forçar máscara
  return str
}
